module.exports = __webpack_public_path__ + "quotezone-ui/img/top-bottom-white.56d2cba0.gif";